"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixImages = exports.isLinkToThumbnail = void 0;

var _memoize = _interopRequireDefault(require("transmute/memoize"));

/**
 *  /S*       - matches any non-whitespace character zero to unlimited times
 *  cdn2      - matches cdn2 literally (case-sensitive)
 *  \.        - matches character . literally (case-sensitive)
 *  net       - matches net literally (case-sensitive)
 *  (qa)?     - matches qa 0 or 1 times
 *  /thumb    - matches /thumb literally (case-sensitive)
 *  [a-zA-Z]+ - match a single character in the range one or more times
 */
var HUBSPOT_HOSTED_THUMBNAIL_REGEX = /\S*cdn2\.hubspot(qa)?\.net\S*\/thumb\.[a-zA-Z]+$/;
var THUMB_REGEX = /\/thumb\.[a-zA-Z]+$/;
var isLinkToThumbnail = (0, _memoize.default)(function (src) {
  return HUBSPOT_HOSTED_THUMBNAIL_REGEX.test(src);
});
exports.isLinkToThumbnail = isLinkToThumbnail;

var fixImages = function fixImages(_ref) {
  var node = _ref.node,
      node_name = _ref.node_name;

  if (node && node_name === 'img' && node.attributes) {
    /**
     * TEMPORARY: Remove "/thumb.<extension>" from "src" so that we point to the full size image.
     *
     * Once https://git.hubteam.com/HubSpot/ConnectedEmail/issues/357 is done,
     * all image "src"s will be backfilled to point to the full size image
     *
     *  */
    var src = node.getAttribute('src');

    if (isLinkToThumbnail(src)) {
      node.setAttribute('src', src.replace(THUMB_REGEX, ''));
    }
    /**
     * TEMPORARY: Overwrite the image width with the full size image width
     *
     * Once https://git.hubteam.com/HubSpot/ConnectedEmail/issues/357 is done,
     * the height and width attributes will be set
     *
     *  */


    if (node.attributes['data-original-width']) {
      node.setAttribute('width', node.attributes['data-original-width'].value);
    }
    /**
     * TEMPORARY: Overwrite the image width with the full size image width
     *
     * Once https://git.hubteam.com/HubSpot/ConnectedEmail/issues/357 is done,
     * the height and width attributes will be set
     *
     *  */


    if (node.attributes['data-original-height']) {
      node.setAttribute('height', node.attributes['data-original-height'].value);
    }

    return {
      node: node
    };
  }

  return null;
};

exports.fixImages = fixImages;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/fixImages.js
// module id = 813
// module chunks = 209 210 211 212